<template>
  <div id="app">
    <!-- 头部导航栏组件 -->
    <Header />

    <!-- 主体内容区域 -->
    <main>
      <router-view />
    </main>

    <!-- 页脚组件 -->
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'; // 导入头部导航栏组件
import Footer from './components/Footer.vue'; // 导入页脚组件

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
/* 可以在这里添加全局样式 */
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}



@media only screen and (max-width: 996px) {
  main {
    flex: 1;
    /* 主体内容区域占据剩余空间 */
    /* padding-top: 20px; */
    /* 设置上内边距 */
    width: 100%;
  }
}

@media only screen and (min-width: 996px) {
  main {
    flex: 1;
    /* 主体内容区域占据剩余空间 */
    /* padding-top: 40px; */
    /* 设置上内边距 */
    width: 100%;
  }
}
</style>
